const models = require('./models');

const rp = require('request-promise');

const FirestoreCrudOperations = require('./firestoreCrudOperations');

const {
  GeoFirestore
} = require('geofirestore');

const ZonedDateTime = require('js-joda').ZonedDateTime;

const {
  subMonths,
  format,
  subDays
} = require('date-fns');

const attributeIds = require('./utils/attributeIds');

const {
  FirestoreModel
} = require("./models/utils/FirestoreModel");

const {
  GeoFirestoreModel
} = require("./models/utils/GeoFirestoreModel");

const GOOGLE_GEOCODING_URL = "https://maps.googleapis.com/maps/api/geocode/json?sensor=false&key=AIzaSyCSvWkVdrGsFpOsrnvCLVFZWpGgtGbrVRw"; // TODO: Refactor these, somewhere...

const INDIVIDUAL_MEMBERSHIP_PURCHASABLE_IDS = ["elite_monthly_membership", "elite_yearly_membership", "individual_membership"];
const LOCATION_MEMBERSHIP_PURCHASABLE_IDS = ["supporting_monthly_membership", "location_membership"];
const MEMBERSHIP_PURCHASABLE_IDS = INDIVIDUAL_MEMBERSHIP_PURCHASABLE_IDS.concat(LOCATION_MEMBERSHIP_PURCHASABLE_IDS);

class NICAApi {
  constructor(rtdb, firestore, functions = null, storage = null, analytics = null) {
    this.db = firestore();
    this.rtdb = rtdb();
    this.geodb = new GeoFirestore(this.db);
    this.GeoPoint = firestore.GeoPoint;
    this.functions = functions ? functions() : null;
    this.storage = storage ? storage() : null;
    this.crudOperations = new FirestoreCrudOperations(this.db, firestore);
    this.analytics = analytics ? analytics() : null;
    this.documentIdField = firestore.FieldPath.documentId();
    models.firestoreModels.forEach(model => {
      const modelClass = model.useGeoFirestore ? GeoFirestoreModel : FirestoreModel;
      this[model.COLLECTION] = new modelClass(this.db, this.functions, model.COLLECTION, model.SCHEMA, model.QUERIES, model.CALLABLES, model.MIXINS, model.convertDates);
    });
  }

  getAllLocations() {
    const locationQuery = this.db.collection(models.location.COLLECTION).orderBy('active');
    return this.crudOperations.runQuery(locationQuery);
  }

  getOrgLocations(orgIds) {
    const locationQuery = this.db.collection(models.location.COLLECTION).where('orgId', 'in', orgIds).orderBy('name');
    return this.crudOperations.runQuery(locationQuery);
  }

  async getUserLocations(orgIds, email, admin = false) {
    let orgLocations = await this.getOrgLocations(orgIds);

    if (admin) {
      let inactiveLocationQuery = this.db.collection(models.location.COLLECTION).where('active', '==', false);
      const inactiveLocations = await this.crudOperations.runQuery(inactiveLocationQuery);
      orgLocations = orgLocations.concat(inactiveLocations);
    }

    const locationQuery = this.db.collection(models.location.COLLECTION).where('users', 'array-contains', email);
    const userLocations = await this.crudOperations.runQuery(locationQuery);
    return orgLocations.concat(userLocations).sort((location1, location2) => {
      if (location1.active) {
        if (location2.active) {
          return location1.name.localeCompare(location2.name);
        }

        return 1;
      } else if (location2.active) {
        return -1;
      }

      return location1.name.localeCompare(location2.name);
    });
  }

  getClaimedLocations() {
    const locationQuery = this.db.collection(models.location.COLLECTION).where('orgId', '>', '');
    return this.crudOperations.runQuery(locationQuery);
  }

  getLocationsWithEmail() {
    const locationQuery = this.db.collection(models.location.COLLECTION).where('emailAddress', '>', '');
    return this.crudOperations.runQuery(locationQuery);
  }

  async getBulkImportLocations() {
    const response = await this.functions.httpsCallable("locations-getBulkImportLocations")({});
    return response.data;
  }

  createBulkUploadRecord() {
    const bulkUpload = {
      started: new Date().toString(),
      completed: false
    };
    const newEntry = this.rtdb.ref("bulk_uploads").push();
    newEntry.set(bulkUpload);
    bulkUpload.key = newEntry.key;
    return bulkUpload;
  }

  updateBulkUpload(bulkUpload) {
    return this.rtdb.ref("bulk_uploads/" + bulkUpload.key).set(bulkUpload);
  }

  getBulkUploadLocations(bulkUploadId) {
    const locationQuery = this.db.collection(models.location.COLLECTION).where('bulkUploadId', '==', bulkUploadId);
    return this.crudOperations.runQuery(locationQuery);
  }

  getLocation(locationId) {
    return this.crudOperations.loadObjectFromFirestore(models.location, locationId);
  }

  getSearchableLocation(locationId) {
    return this.crudOperations.loadObjectFromFirestore({
      COLLECTION: "searchableLocations"
    }, locationId);
  }

  saveLocation(location) {
    return this.crudOperations.writeObjectToFirestore(models.location, location);
  }

  deleteLocation(locationId) {
    return this.crudOperations.removeObjectFromFirestore(models.location, locationId);
  }

  async saveSearchableLocation(location) {
    // KBM - Maybe could move this into crud operations, but don't see the benefit atm
    return await this.geodb.collection('searchableLocations').doc(location.id).set({ ...location,
      coordinates: new this.GeoPoint(location.latitude, location.longitude)
    });
  }

  deleteSearchableLocation(locationId) {
    // KBM - Maybe could move this into crud operations, but don't see the benefit atm
    return this.geodb.collection('searchableLocations').doc(locationId).delete();
  }
  /**
   * Fetches the attributes from the RTDB. Need to consider if we want to migrate these to Firestore
   */


  async getAttributes() {
    const results = [];
    const attributesSnapshot = await this.rtdb.ref("attributes").once("value");
    attributesSnapshot.forEach(childSnapshot => {
      const attribute = childSnapshot.val();
      attribute.key = childSnapshot.key;
      results.push(attribute);
    });
    return results;
  }

  async fetchPurchaseHistory(orgIds) {
    // var history = [];
    // const snapshot = await this.rtdb.ref(`/purchase_history/${orgId}`).orderByChild('purchaseDate').once('value');
    // snapshot.forEach(childSnapshot => {
    //     var historyItem = childSnapshot.val();
    //     historyItem.key = childSnapshot.key;
    //     history.unshift(historyItem);
    // });
    // return history;
    const query = this.db.collection(models.purchase.COLLECTION).where('orgId', 'in', orgIds).where('completed', '==', true).orderBy('createdAt', 'desc');
    return this.crudOperations.runQuery(query);
  }

  getAllActivePurchases() {
    return this.rtdb.ref(`/active_purchases`).once('value');
  }

  getAllActivePurchasables() {
    const query = this.db.collection(models.activePurchasable.COLLECTION);
    return this.crudOperations.runQuery(query);
  }

  getActivePurchases(orgIds) {
    const query = this.db.collection(models.activePurchasable.COLLECTION).where('orgId', 'in', orgIds);
    return this.crudOperations.runQuery(query);
  }

  watchActivePurchases(orgIds, callback) {
    return this.db.collection(models.activePurchasable.COLLECTION).where('orgId', 'in', orgIds).onSnapshot(querySnapshot => {
      callback(querySnapshot.docs.map(this.crudOperations.convertFromFirestoreDoc));
    });
  }

  async saveActivePurchases(user, cart, purchaseId) {
    const snapshot = await this.getActivePurchases(user.orgId);
    const activePurchases = snapshot.val() || {};
    cart.forEach(cartItem => {
      let activePurchase = {
        purchaseDate: ZonedDateTime.now().withFixedOffsetZone().toString(),
        credits: cartItem.resource.pricing[cartItem.selectedOption].credits,
        purchaseId,
        locations: {}
      };

      if (activePurchases[cartItem.resource.id]) {
        activePurchase = activePurchases[cartItem.resource.id];
        activePurchase.credits += cartItem.resource.pricing[cartItem.selectedOption].credits;
      }

      if (cartItem.locations) {
        let locations = activePurchase.locations || {};
        cartItem.locations.forEach(location => {
          locations[location.id] = {
            name: location.name,
            address: location.address,
            credits: cartItem.resource.pricing[cartItem.selectedOption].credits + (locations[location.id] ? locations[location.id].credits : 0),
            purchaseDate: activePurchase.purchaseDate
          };
        });
      }

      activePurchases[cartItem.resource.id] = activePurchase;
    });
    await this.rtdb.ref(`/active_purchases/${user.orgId}`).set(activePurchases);
    return activePurchases;
  }

  async savePurchase(purchase) {
    // const snapshot = await this.rtdb.ref(`/purchase_history/${user.orgId}`).push({
    //     amount: total,
    //     customer: customer.id,
    //     user: user,
    //     purchaseDate: new Date().toISOString(),
    //     cart: cart
    // });
    //
    // return this.rtdb.ref(`/purchase_history/${user.orgId}/${snapshot.key}`);
    return this.crudOperations.writeObjectToFirestore(models.purchase, purchase);
  }

  async fetchAdminReport(startDate, endDate) {
    const fetchQueries = async (queries, type, limit, offset, resolve) => {
      console.log(`fetching ${type} queries`, limit, offset);
      const result = await this.functions.httpsCallable("search-adminReportQuery")({
        startDate,
        endDate,
        type,
        limit,
        offset
      });

      if (!result.data.length) {
        return resolve(queries);
      } else if (result.data.length < limit) {
        return resolve(queries.concat(result.data));
      }

      return fetchQueries(queries.concat(result.data), type, limit, offset + result.data.length, resolve);
    };

    const fetchAllQueries = async type => {
      return new Promise((resolve, reject) => {
        return fetchQueries([], type, 50000, 0, resolve);
      });
    };

    const queries = ["all", "specialties", "medications"];
    const report = await Promise.all(queries.map(query => fetchAllQueries(query)));
    return {
      all: report[0],
      specialties: report[1],
      medicationsAvailable: report[2]
    };
  }

  async getAdminResources() {
    let query = this.db.collection(models.purchasable.COLLECTION).where('path', '==', '/admin_resources/');
    return this.crudOperations.runQuery(query);
  }

  async getMemberResources() {
    const snapshot = await this.rtdb.ref('/member_resources').once('value');
    return snapshot.val();
  }

  async uploadAdminResource(file, resource, notify) {
    const snapshot = await this.storage.ref().child(`${resource.path}${file.name}`).put(file);
    const update = await this.updateAdminResourceUrl(snapshot, resource);

    if (notify) {
      await this.createAdminResourceNotifyEvent(resource);
    }

    return update;
  }

  async updateAdminResourceUrl(snapshot, resource) {
    const url = await snapshot.ref.getDownloadURL();
    const update = { ...resource,
      downloadUrl: url,
      lastUpdated: new Date().toISOString()
    };
    return this.crudOperations.writeObjectToFirestore(models.purchasable, update);
  }

  createAdminResourceNotifyEvent(resource) {
    return this.rtdb.ref('admin_resource_notify_events').push({
      date: new Date().toISOString(),
      resource: resource
    });
  }

  createCustomer(email, token) {
    return this.functions.httpsCallable("stripe-createCustomer")({
      email,
      token
    });
  }

  cancelSubscription(subscriptionId, purchaseId) {
    return this.functions.httpsCallable("stripe-cancelSubscription")({
      subscriptionId,
      purchaseId
    });
  }

  removeSubscription(orgId, purchaseId, cartIndex) {
    return this.rtdb.ref(`/purchase_history/${orgId}/${purchaseId}/cart/${cartIndex}/stripe_subscription`).remove();
  }

  getLocationReport(locationId, startDate, endDate) {
    return this.functions.httpsCallable("locationReports-getLocationReport")({
      locationId,
      startDate,
      endDate
    });
  }

  getTotalSearches(startDate, endDate) {
    return this.functions.httpsCallable("locationReports-getTotalSearches")({
      startDate,
      endDate
    });
  }
  /**
   * TODO: Need to add the new sort method in here
   * @param lat
   * @param lng
   * @param radiusInMiles
   * @param domain
   * @returns {Promise<unknown[]>}
   */


  async searchLocations(lat, lng, radiusInMiles, domain = null) {
    const radiusInKms = radiusInMiles * 1.60934;
    const query = this.geodb.collection("searchableLocations").near({
      center: new this.GeoPoint(lat, lng),
      radius: radiusInKms
    });
    const snapshot = await query.get();
    return snapshot.docs.map(doc => {
      const result = this.crudOperations.convertFromFirestoreDoc(doc);
      result.distance = doc.distance;
      return result;
    }).filter(location => {
      if (domain && location.blacklistDomains) {
        return !location.blacklistDomains.includes(domain);
      }

      return true;
    }).sort(_defaultSort);
  }

  async geocodeAddress(address) {
    const options = {
      uri: `${GOOGLE_GEOCODING_URL}&address=${address}`,
      method: 'GET'
    };

    try {
      const result = await rp(options);
      const data = JSON.parse(result);

      if (data.results.length) {
        const lat = data.results[0].geometry.location.lat;
        const lng = data.results[0].geometry.location.lng;
        return {
          lat,
          lng
        };
      }
    } catch (error) {
      console.error(error);
      return false;
    }

    return false;
  }

  getLocationsLastUpdatedBefore(timestamp) {
    const locationQuery = this.db.collection(models.location.COLLECTION).where('updatedAt', '<', timestamp);
    return this.crudOperations.runQuery(locationQuery);
  }

  async getSubscriptionPurchase(subscriptionId) {
    const snapshot = await this.rtdb.ref(`/subscription_purchase/${subscriptionId}`).once('value');
    return snapshot.val();
  }

  async getPurchaseHistoryItem(orgId, purchaseId) {
    const snapshot = await this.rtdb.ref(`/purchase_history/${orgId}/${purchaseId}/`).once('value');
    return snapshot.val();
  }

  saveUnprocessedCharge(orgId, purchaseId, amount, items, customer, user) {
    return this.rtdb.ref(`/purchase_history/${orgId}/${purchaseId}/charge`).set({
      amount,
      items,
      customer,
      currency: "USD",
      user
    });
  }

  saveUnprocessedSubscriptions(orgId, purchaseId, subscriptionItems, customer, user) {
    return Promise.all(subscriptionItems.map((item, index) => this.rtdb.ref(`purchase_history/${orgId}/${purchaseId}/subscriptions`).push({
      item,
      customer,
      user
    })));
  }

  saveStripeCharge(orgId, purchaseId, stripeCharge) {
    return this.rtdb.ref(`/purchase_history/${orgId}/${purchaseId}/charge/stripe_charge`).set(stripeCharge);
  }

  saveStripeChargeError(orgId, purchaseId, message) {
    return this.rtdb.ref(`/purchase_history/${orgId}/${purchaseId}/charge/stripe_error`).set(message);
  }

  async getStripePlan(planId) {
    const snapshot = await this.rtdb.ref(`/stripe_plans/${planId}`).once('value');
    return snapshot.val();
  }

  saveStripePlan(plan) {
    return this.rtdb.ref(`/stripe_plans/${plan.id}`).set(plan);
  }

  async saveStripeSubscription(orgId, purchaseId, cartIndex, subscription, subscriptionId) {
    subscription.created = ZonedDateTime.now().withFixedOffsetZone().toString();
    await this.rtdb.ref(`/purchase_history/${orgId}/${purchaseId}/subscriptions/${subscriptionId}/stripe_subscription`).set(subscription);
    return this.rtdb.ref(`/purchase_history/${orgId}/${purchaseId}/cart/${cartIndex}/stripe_subscription`).set(subscription);
  }

  saveOrgSubscription(orgId, subscription, stripeSubscription) {
    return this.rtdb.ref(`/subscriptions/${orgId}`).push({
      subscription,
      stripe_subscription: stripeSubscription
    });
  }

  saveSubscriptionPurchase(orgId, purchaseId, stripeSubscription) {
    return this.rtdb.ref(`/subscription_purchase/${stripeSubscription.id}`).set({
      orgId,
      purchaseId
    });
  }

  saveStripeSubscriptionError(orgId, purchaseId, subscriptionId, message) {
    return this.rtdb.ref(`/purchase_history/${orgId}/${purchaseId}/subscriptions/${subscriptionId}/stripe_error`).set(message);
  }

  updatePurchase(orgId, purchase, purchaseKey) {
    return this.rtdb.ref(`/active_purchases/${orgId}/${purchaseKey}`).update(purchase);
  }

  removePurchase(orgId, purchaseKey) {
    return this.rtdb.ref(`/active_purchases/${orgId}/${purchaseKey}`).remove();
  }

  async getPurchasedByEmail(orgId, id) {
    const snapshot = await this.rtdb.ref(`purchase_history/${orgId}/${id}/user/email`).once('value');
    return snapshot.val();
  }

  async getSurveyQuestions(success) {
    const snapshot = await this.rtdb.ref("surveyQuestions").once('value');
    return snapshot.val();
  }

  async fetchWordPressUser(isDev) {
    const options = {
      uri: `https://infusioncenter.org/locator-token/${isDev ? "?dev=true" : ""}`,
      withCredentials: true,
      method: 'GET',
      headers: {
        'Accept': '*/*',
        'Content-Type': 'application/json'
      }
    };

    try {
      const result = await rp(options);
      return JSON.parse(result);
    } catch (err) {
      console.error(err);
    }

    return null;
  }

  async uploadFile(file, uid) {
    const parts = file.name.split(".");
    const extension = parts[parts.length - 1];
    const storageRef = this.storage.ref();
    const fileRef = storageRef.child(uid + "." + extension);
    const snapshot = await fileRef.put(file);
    const downloadUrl = await snapshot.ref.getDownloadURL();
    return downloadUrl;
  }

  claimLocation(displayName, email, orgId, locationId, locationName) {
    return this.rtdb.ref("claimRequest").push({
      userDisplayName: displayName,
      userEmail: email,
      orgId: orgId,
      locationName: locationName,
      locationId: locationId
    });
  }

  createBulkMessage(locationIds, message) {
    return this.rtdb.ref("bulkMessage").push({
      locationIds,
      message,
      created: new Date().toString()
    });
  }

  getAdminEmails() {
    return this.rtdb.ref("emailRecipients").once("value");
  }

  createLocationContactRequest(name, email, phone, subject, message, locationId) {
    return this.rtdb.ref("contactEmails").push({
      name,
      email,
      phone,
      subject,
      message,
      locationId,
      sent: false
    });
  }

  shareLocation(fromName, toName, toEmail, message, locationId) {
    return this.rtdb.ref("shareEmails").push({
      fromName,
      toName,
      toEmail,
      message,
      locationId,
      sent: false
    });
  }

  getSponsors() {
    return this.rtdb.ref("sponsors").once("value");
  }

  trackEvent(eventName, eventParams) {
    if (this.analytics) {
      this.analytics.logEvent(eventName, eventParams);
    }
  }

  logSearch(query, radius, lat, lng, userIP = '') {
    if (lat && lng) {
      const searchRef = this.rtdb.ref('/reports/searches/queries').push({
        query,
        radius,
        lat,
        lng,
        userIP,
        domain: document.domain
      });
      return searchRef.key;
    }

    return null;
  }

  logSpecialtyFilter(searchId, specialties) {
    if (specialties && specialties.length) {
      return Promise.all(specialties.map(specialty => this.rtdb.ref(`/reports/searches/filters/specialty/${specialty.key}`).update({
        [searchId]: true
      })));
    }

    return null;
  }

  logMedicationFilter(searchId, medications) {
    if (medications && medications.length) {
      return Promise.all(medications.map(medication => this.rtdb.ref(`/reports/searches/filters/medication/${medication.key}`).update({
        [searchId]: true
      })));
    }

    return null;
  }

  logLocationDetailView(locationId) {
    return this.rtdb.ref(`/reports/locations/${locationId}/visits`).push({
      date: new Date().toString()
    }).key;
  }

  logLocationClick(locationId, type, visitId) {
    return this.rtdb.ref(`/reports/locations/${locationId}/${type}`).push({
      visit: visitId,
      date: new Date().toString()
    });
  }

  saveOrganization(organization) {
    return this.crudOperations.writeObjectToFirestore(models.organization, organization);
  }

  getOrganization(orgId) {
    return this.crudOperations.loadObjectFromFirestore(models.organization, orgId);
  }

  getOrganizations(orgIds) {
    const query = this.db.collection(models.organization.COLLECTION).where(this.documentIdField, 'in', orgIds);
    return this.crudOperations.runQuery(query);
  }

  getUserOrganizations(email) {
    const orgQuery = this.db.collection(models.organization.COLLECTION).where('emails', 'array-contains', email);
    return this.crudOperations.runQuery(orgQuery);
  }

  watchUserOrganizations(email, callback) {
    return this.db.collection(models.organization.COLLECTION).where('emails', 'array-contains', email).onSnapshot(querySnapshot => {
      callback(querySnapshot.docs.map(this.crudOperations.convertFromFirestoreDoc));
    });
  }

  async getOwnerOrganization(email) {
    const orgQuery = this.db.collection(models.organization.COLLECTION).where('owner.email', '==', email);
    const results = await this.crudOperations.runQuery(orgQuery);
    return results.length ? results[0] : null;
  }

  getAllPurchasables() {
    const purchasablesQuery = this.db.collection(models.purchasable.COLLECTION).orderBy('order');
    return this.crudOperations.runQuery(purchasablesQuery);
  }

  saveActivePurchasable(activePurchasable) {
    return this.crudOperations.writeObjectToFirestore(models.activePurchasable, activePurchasable);
  }

  checkout(orgId, total, user, cart, contactInfo, token, paymentType) {
    return this.functions.httpsCallable("stripe-processPurchase")({
      orgId,
      total,
      user,
      cart,
      contactInfo,
      token,
      paymentType
    });
  }

  getActivePurchasablesByStripeSubscriptionId(subscriptionId) {
    const query = this.db.collection(models.activePurchasable.COLLECTION).where('stripeSubscriptionId', '==', subscriptionId);
    return this.crudOperations.runQuery(query);
  }

  getPurchase(purchaseId) {
    return this.crudOperations.loadObjectFromFirestore(models.purchase, purchaseId);
  }

  getUserToken(userEmail) {
    return this.functions.httpsCallable("users-getAuthToken")({
      userEmail
    });
  }

  saveAttribute(attribute) {
    return this.crudOperations.writeObjectToFirestore(models.attribute, attribute);
  }

  getMemberLocations() {
    const query = this.db.collection(models.location.COLLECTION).where('isMember', '==', true);
    return this.crudOperations.runQuery(query);
  }

  getOrgActivePurchasablesByPurchasableId(orgId, purchasableId, locationId = null) {
    let query = this.db.collection(models.activePurchasable.COLLECTION).where('orgId', '==', orgId).where('purchasableId', '==', purchasableId);

    if (locationId) {
      query = query.where('location.id', '==', locationId);
    }

    return this.crudOperations.runQuery(query);
  }

  getActivePurchasablesByPurchasableId(purchasableId) {
    let query = this.db.collection(models.activePurchasable.COLLECTION).where('purchasableId', '==', purchasableId);
    return this.crudOperations.runQuery(query);
  }

  getAutoRenewActivePurchasables() {
    const query = this.db.collection(models.activePurchasable.COLLECTION).where('autoRenew', '==', true);
    return this.crudOperations.runQuery(query);
  }

  getAutoRenewActivePurchasablesByPurchasableId(purchasableId) {
    const query = this.db.collection(models.activePurchasable.COLLECTION).where('purchasableId', '==', purchasableId).where('autoRenew', '==', true);
    return this.crudOperations.runQuery(query);
  }

  getExpiringActivePurchasablesByPurchasableId(purchasableId) {
    const query = this.db.collection(models.activePurchasable.COLLECTION).where('purchasableId', '==', purchasableId).where('autoRenew', '==', false);
    return this.crudOperations.runQuery(query);
  }

  getExpiringActivePurchasables(creditsRemaining) {
    const query = this.db.collection(models.activePurchasable.COLLECTION).where('creditsRemaining', '<=', creditsRemaining).where('autoRenew', '==', false);
    return this.crudOperations.runQuery(query);
  }

  deleteActivePurchasable(activePurchasableId) {
    return this.crudOperations.removeObjectFromFirestore(models.activePurchasable, activePurchasableId);
  } // getAutoRenewActivePurchasesByPurchasableId(purchasableId) {
  //     let query = this.db.collection(models.activePurchasable.COLLECTION)
  //         .where('purchasableId', '==', purchasableId)
  //         .where('autoRenew', '==', true);
  //     return this.crudOperations.runQuery(query);
  // }


  async getAutoRenewMembershipActivePurchasables() {
    const individuals = await this.getAutoRenewActivePurchasablesByPurchasableId("individual_membership");
    const locations = await this.getAutoRenewActivePurchasablesByPurchasableId("location_membership");
    return individuals.concat(locations);
  }

  async getExpiringMembershipActivePurchasables() {
    const individuals = await this.getExpiringActivePurchasablesByPurchasableId("individual_membership");
    const locations = await this.getExpiringActivePurchasablesByPurchasableId("location_membership");
    return individuals.concat(locations);
  }

  async getMembershipsReport() {
    const pattern = "yyyy-MM-dd";
    const createdStartDate = format(subMonths(new Date(), 6), pattern);
    const expiredStartDate = format(subMonths(new Date(), 12), pattern);
    const result = await this.functions.httpsCallable("memberships-getMembershipReport")({
      createdStartDate,
      expiredStartDate
    });
    const {
      created,
      expired
    } = result.data;
    const memberLocations = await this.getMemberLocations();
    const autoRenewMemberships = await this.getAutoRenewMembershipActivePurchasables();
    const expiringMemberships = await this.getExpiringMembershipActivePurchasables();
    return {
      created,
      expired,
      memberLocations,
      autoRenewMemberships,
      expiringMemberships
    };
  }

  async getPurchasablesReport() {
    const pattern = "yyyy-MM-dd";
    const createdStartDate = format(subMonths(new Date(), 6), pattern);
    const expiredStartDate = format(subMonths(new Date(), 12), pattern);
    const result = await this.functions.httpsCallable("purchasables-getPurchasablesReport")({
      createdStartDate,
      expiredStartDate
    });
    const {
      created,
      expired
    } = result.data;
    const autoRenews = await this.getAutoRenewActivePurchasables();
    const expiring = await this.getExpiringActivePurchasables(12);
    return {
      created,
      expired,
      autoRenews,
      expiring
    };
  }

  getMembershipsForLocations() {
    const query = this.db.collection(models.activePurchasable.COLLECTION).where('purchasableId', '==', "location_membership") // .where('location.id', 'in', locationIds)
    .orderBy('updatedAt', 'desc');
    return this.crudOperations.runQuery(query);
  }

  getMembershipsById(membershipIds) {
    const query = this.db.collection(models.activePurchasable.COLLECTION).where(this.documentIdField, 'in', membershipIds); // .orderBy('updatedAt', 'desc'); // KBM - Not sure why this didn't work, but whatevs

    return this.crudOperations.runQuery(query);
  }

  async generateAdminLocationReport() {
    const locations = await this.getAllLocations();
    const specialties = {};
    const medicationsAvailable = {};
    const sparseLocations = locations.map(location => {
      const {
        id,
        latitude,
        longitude,
        orgId,
        numberOfChairs
      } = location; // Parse out attributes

      if (location.attributes) {
        // First, Specialties
        if (location.attributes[attributeIds.practiceSpecialty] && location.attributes[attributeIds.practiceSpecialty].choice) {
          location.attributes[attributeIds.practiceSpecialty].choice.forEach(specialtyId => {
            if (specialties[specialtyId]) {
              specialties[specialtyId].push(id);
            } else {
              specialties[specialtyId] = [id];
            }
          });
        } // Then, Medications Available


        attributeIds.medicationGroups.forEach(groupId => {
          if (location.attributes[groupId] && location.attributes[groupId].choice) {
            location.attributes[groupId] && location.attributes[groupId].choice.forEach(medicationId => {
              if (medicationsAvailable[medicationId]) {
                medicationsAvailable[medicationId].push(id);
              } else {
                medicationsAvailable[medicationId] = [id];
              }
            });
          }
        });
      }

      return {
        id,
        lat: latitude,
        lng: longitude,
        claimed: Boolean(orgId),
        numberOfChairs: numberOfChairs || 1
      };
    });
    return this.rtdb.ref('/adminLocationReport').set({
      locations: sparseLocations,
      specialties,
      medicationsAvailable
    });
  }

  async getAdminLocationReport() {
    const snapshot = await this.rtdb.ref('/adminLocationReport').once('value');
    return snapshot.val();
  }

  async getOrgMemberships(orgIds) {
    // const query = this.db.collection(models.activePurchasable.COLLECTION)
    //     .where('orgId', 'in', orgIds)
    //     .orderBy('updatedAt', 'desc');
    const activePurchasables = await this.getActivePurchases(orgIds);
    return activePurchasables.filter(purchasable => MEMBERSHIP_PURCHASABLE_IDS.includes(purchasable.purchasableId));
  }

  async getUsersIP() {
    const response = await this.functions.httpsCallable("users-getIP")({});
    return response.data;
  }

  async getUserInfo(domain) {
    const response = await this.functions.httpsCallable("users-getUserInfo")({
      domain
    });
    return response.data;
  }

  logAdminError(error, errorInfo, userClaims) {
    return this.rtdb.ref('admin_errors').push({
      error,
      errorInfo,
      email: userClaims ? userClaims.email : "",
      date: new Date().toString()
    });
  }

  logRateLimitExceeded(userIP, domain) {
    return this.rtdb.ref('rate_limit_exceeded').push({
      userIP,
      timestamp: new Date().getTime(),
      domain
    });
  }

  blacklistIP(userIP, domain) {
    return this.crudOperations.writeObjectToFirestore(models.blacklist, {
      userIP,
      blacklistDate: new Date(),
      domain
    });
  }

  async isBlacklisted(userIP, domain) {
    const query = this.db.collection(models.blacklist.COLLECTION).where('userIP', '==', userIP).where('domain', '==', domain);
    const result = await this.crudOperations.runQuery(query);
    return result.length > 0;
  }

  async getRateLimitsExceededBy(userIP, startDate, domain) {
    const results = [];
    const snapshot = await this.rtdb.ref('rate_limit_exceeded').orderByChild('userIP').startAt(userIP).endAt(userIP).once('value');
    snapshot.forEach(childSnapshot => {
      if (childSnapshot.val().timestamp > startDate.getTime() && childSnapshot.val().domain === domain) {
        results.push(childSnapshot.val());
      }
    });
    return results;
  }

  async deleteExpiredBlacklistItems() {
    const snapshot = await this.db.collection(models.blacklist.COLLECTION).where('blacklistDate', '<=', subMonths(new Date(), 1)).get();
    return Promise.all(snapshot.docs.map(doc => this.crudOperations.removeObjectFromFirestore(models.blacklist, doc.id)));
  }

  async deleteExpiredWhitelistItems() {
    const snapshot = await this.db.collection(models.whitelist.COLLECTION).where('expirationDate', '<=', new Date()).get();
    return Promise.all(snapshot.docs.map(doc => this.crudOperations.removeObjectFromFirestore(models.whitelist, doc.id)));
  }

  async getWhitelistItemByIP(userIP, domain) {
    const query = this.db.collection(models.whitelist.COLLECTION).where('userIP', '==', userIP).where('domain', '==', domain);
    const results = await this.crudOperations.runQuery(query);

    if (results && results.length) {
      return results[0];
    }

    return null;
  }

}

const _defaultSort = (item1, item2) => {
  // First, Sponsored Locations
  if (item1.isPreferred) {
    if (!item2.isPreferred) {
      return -1;
    }
  } else if (item2.isPreferred) {
    return 1;
  } // Next, Member Locations


  if (item1.isMember) {
    if (!item2.isMember) {
      return -1;
    }
  } else if (item2.isMember) {
    return 1;
  } // Then, Claimed Locations


  if (item1.orgId) {
    if (!item2.orgId) {
      return -1;
    }
  } else if (item2.orgId) {
    return 1;
  } // Finally, Distance


  if (item1.distance < item2.distance) {
    return -1;
  } else if (item1.distance === item2.distance) {
    return 0;
  }

  return 1;
};

module.exports = NICAApi;